import {
  addCharter,
  getAirportsDetails,
  getAirlineDetails,
} from "app/services/charterService";
import axios from "axios";
import React, { Component } from "react";
import { useState } from "react";
import Autosuggest from "react-autosuggest";

function AirportDestination(props) {
  const [state, setState] = useState({
    value: "",
    suggestions: [],
  });

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAirportsDetails(value);
    const airportDetails = [];

    data.map((detail) =>
      airportDetails.push({
        id: detail.id,
        label: `${detail.cityName} ${detail.cityCode}`,
      })
    );
    return airportDetails;
  };

  const onSuggestionSelected = (id, suggestionValue) => {
    setState((prev) => ({ ...prev, value: suggestionValue.label }));
    props.setFieldValue(id, suggestionValue.id);
  };

  // Trigger suggestions
  const getSuggestionValue = (suggestion) => suggestion;

  // Render Each Option
  const renderSuggestion = (suggestion) => <div>{suggestion.label}</div>;

  // OnChange event handler
  const onChange = (event, { newValue }) => {
    setState((prev) => ({ ...prev, value: newValue }));
    props.setFieldValue(
      `flightLegs.onward[${props.index}].airportDestinationId`,
      ""
    );
  };

  // Suggestion rerender when user types
  const onSuggestionsFetchRequested = ({ value }) => {
    getSuggestions(value).then((data) => {
      if (data.Error) {
        setState((prev) => ({ ...prev, suggestions: [] }));
      } else {
        setState((prev) => ({ ...prev, suggestions: data }));
      }
    });
  };

  // Triggered on clear
  const onSuggestionsClearRequested = () => {
    setState((prev) => ({ ...prev, suggestions: [] }));
  };

  const { value, suggestions } = state;

  // Option props
  const inputProps = {
    placeholder: "Airport Destination",
    value,
    onChange: onChange,
    className: "form-control",
    id: `flightLegs.onward[${props.index}].airportDestinationId`,
    name: `flightLegs.onward[${props.index}].airportDestinationId`,
  };

  // Adding AutoSuggest component
  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      onSuggestionSelected={(event, { suggestionValue }) => {
        onSuggestionSelected(
          `flightLegs.onward[${props.index}].airportDestinationId`,
          suggestionValue
        );
      }}
    />
  );
}
export default AirportDestination;
